"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var in_dom_1 = require("./util/in-dom");
var style_1 = require("./style");
var isDoc = function (obj) { return obj != null && obj.nodeType === obj.DOCUMENT_NODE; };
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function closest(node, selector, context) {
    while (node && (isDoc(node) || !exports.matches(node, selector))) {
        node = node !== context && !isDoc(node) ? node.parentNode : undefined;
    }
    return node;
}
exports.closest = closest;
exports.contains = (function () {
    var root = in_dom_1.inDOM && document.documentElement;
    return (root && root.contains)
        ? function (context, node) {
            return context.contains(node);
        }
        : (root && root.compareDocumentPosition)
            ? function (context, node) {
                return context === node || !!(context.compareDocumentPosition(node) & 16);
            }
            : function (context, node) {
                if (node)
                    do {
                        if (node === context)
                            return true;
                    } while ((node = node.parentNode));
                return false;
            };
})();
function height(node, client) {
    var win = getWindow(node);
    return win
        ? win.innerHeight
        : client
            ? node.clientHeight
            : offset(node).height;
}
exports.height = height;
exports.matches = (function () {
    if (!in_dom_1.inDOM) {
        throw new Error('Not in DOM');
    }
    var body = document.body;
    var nativeMatch = body.matches
        || body.matchesSelector
        || body.webkitMatchesSelector
        || body.mozMatchesSelector
        || body.msMatchesSelector;
    return function (node, selector) { return nativeMatch.call(node, selector); };
})();
function offset(node) {
    var doc = ownerDocument(node), win = getWindow(doc), docElem = doc && doc.documentElement, box = { top: 0, left: 0, height: 0, width: 0 };
    if (!doc) {
        throw new Error('No document found');
    }
    // Make sure it's not a disconnected DOM node
    if (!exports.contains(docElem, node))
        return box;
    if (node.getBoundingClientRect !== undefined)
        box = node.getBoundingClientRect();
    if (box.width || box.height) {
        box = {
            top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
            left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
            width: (box.width == null ? node.offsetWidth : box.width) || 0,
            height: (box.height == null ? node.offsetHeight : box.height) || 0
        };
    }
    return box;
}
exports.offset = offset;
function getOffsetParent(node) {
    var doc = ownerDocument(node);
    var parentOffset = node && node.offsetParent;
    while (parentOffset && nodeName(node) !== 'html' && style_1.getCss(parentOffset, 'position') === 'static') {
        parentOffset = parentOffset.offsetParent;
    }
    return parentOffset || doc.documentElement;
}
exports.getOffsetParent = getOffsetParent;
function position(node, offsetParent) {
    var parentOffset = { top: 0, left: 0 };
    var windowOffset;
    // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
    // because it is its only offset parent
    if (style_1.getCss(node, "position") === "fixed") {
        windowOffset = node.getBoundingClientRect();
    }
    else {
        offsetParent = offsetParent || getOffsetParent(node);
        windowOffset = offset(node);
        if (nodeName(offsetParent) !== 'html') {
            parentOffset = offset(offsetParent);
        }
        parentOffset.top += (parseInt(style_1.getCss(offsetParent, 'borderTopWidth'), 10) - getScrollTop(offsetParent)) || 0;
        parentOffset.left += (parseInt(style_1.getCss(offsetParent, 'borderLeftWidth'), 10) - getScrollLeft(offsetParent)) || 0;
    }
    // Subtract parent offsets and node margins
    return Object.assign({}, windowOffset, {
        top: windowOffset.top - parentOffset.top - (parseInt(style_1.getCss(node, 'marginTop'), 10) || 0),
        left: windowOffset.left - parentOffset.left - (parseInt(style_1.getCss(node, 'marginLeft'), 10) || 0)
    });
}
exports.position = position;
function querySelectorAll(element, selector) {
    var maybeID = selector[0] === '#', maybeClass = selector[0] === '.', nameOnly = (maybeID || maybeClass) ? selector.slice(1) : selector, isSimple = simpleSelectorRE.test(nameOnly), found;
    if (isSimple) {
        if (maybeID) {
            element = element.getElementById ? element : document;
            return (found = element.getElementById(nameOnly)) ? [found] : [];
        }
        if (element.getElementsByClassName && maybeClass)
            return toArray(element.getElementsByClassName(nameOnly));
        return toArray(element.getElementsByTagName(selector));
    }
    return toArray(element.querySelectorAll(selector));
}
exports.querySelectorAll = querySelectorAll;
function scrollParent(node) {
    var position = style_1.getCss(node, 'position'), excludeStatic = position === 'absolute', ownerDoc = node.ownerDocument;
    if (position === 'fixed')
        return ownerDoc || document;
    while ((node = node.parentNode) && node.nodeType !== 9) {
        var isStatic = excludeStatic && style_1.getCss(node, 'position') === 'static';
        var style = style_1.getCss(node, 'overflow')
            + style_1.getCss(node, 'overflow-y')
            + style_1.getCss(node, 'overflow-x');
        if (isStatic)
            continue;
        if ((/(auto|scroll)/).test(style) && height(node) < node.scrollHeight)
            return node;
    }
    return document;
}
exports.scrollParent = scrollParent;
function getScrollTop(node) {
    var win = getWindow(node);
    return win
        ? ('pageYOffset' in win)
            ? win.pageYOffset
            : win.document.documentElement.scrollTop
        : node.scrollTop;
}
exports.getScrollTop = getScrollTop;
function setScrollTop(node, val) {
    var win = getWindow(node);
    if (win)
        win.scrollTo(('pageXOffset' in win)
            ? win.pageXOffset
            : win.document.documentElement.scrollLeft, val);
    else
        node.scrollTop = val;
}
exports.setScrollTop = setScrollTop;
function width(node, client) {
    var win = getWindow(node);
    return win
        ? win.innerWidth
        : client
            ? node.clientWidth
            : offset(node).width;
}
exports.width = width;
function getScrollLeft(node) {
    var win = getWindow(node);
    return win
        ? ('pageXOffset' in win)
            ? win.pageXOffset
            : win.document.documentElement.scrollLeft
        : node.scrollLeft;
}
function setScrollLeft(node, val) {
    var win = getWindow(node);
    if (win)
        win.scrollTo(val, ('pageYOffset' in win)
            ? win.pageYOffset
            : win.document.documentElement.scrollTop);
    else
        node.scrollLeft = val;
}
function getWindow(node) {
    return node === node.window
        ? node
        : node.nodeType === 9
            ? node.defaultView || node.parentWindow
            : false;
}
exports.getWindow = getWindow;
function nodeName(node) {
    return node.nodeName && node.nodeName.toLowerCase();
}
function ownerDocument(node) {
    return (node && node.ownerDocument) || document;
}
exports.ownerDocument = ownerDocument;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/dom-helpers/query.js
// module id = 94
// module chunks = 0 1 2 3 4 5 6